import axios from "axios"

const mlBaseUrl = import.meta.env.VITE_ML_BASE_URL
const mlAccessToken = import.meta.env.VITE_ML_ACCESS_TOKEN

const axiosPrivateMl = axios.create({
  baseURL: mlBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
})

axiosPrivateMl.interceptors.request.use(
  (config) => {
    if (mlAccessToken) {
      config.headers.Authorization = `Bearer ${mlAccessToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosPrivateMl.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message === "Invalid or expired token"
    ) {
      // clearToken()
    }
    return Promise.reject(error)
  }
)

export default axiosPrivateMl
